import { useMemo } from "react";
import { Badge } from "@/components/ui/Badge";
import { selectActiveForce, useForceStore } from "@/store/forceStore";
import { validateForce } from "@/utils/validation";

export function ValidationPanel() {
	const force = useForceStore(selectActiveForce);
	const errors = useMemo(() => (force ? validateForce(force) : []), [force]);

	if (!force) return null;

	const errorCount = errors.filter((e) => e.type === "error").length;
	const warningCount = errors.filter((e) => e.type === "warning").length;

	if (errors.length === 0) {
		return (
			<div className="p-3 rounded-md bg-accent-primary/5 border border-accent-primary/20">
				<span className="text-sm text-accent-primary font-medium">Force is valid</span>
			</div>
		);
	}

	return (
		<div className="space-y-2">
			<div className="flex items-center gap-2">
				<h3 className="text-xs font-semibold text-text-muted uppercase tracking-wider">
					Validation
				</h3>
				{errorCount > 0 && (
					<Badge variant="red" size="sm">
						{errorCount} error{errorCount !== 1 ? "s" : ""}
					</Badge>
				)}
				{warningCount > 0 && (
					<Badge variant="amber" size="sm">
						{warningCount} warning{warningCount !== 1 ? "s" : ""}
					</Badge>
				)}
			</div>
			<div className="space-y-1 max-h-48 overflow-y-auto">
				{errors.map((err, idx) => (
					<div
						key={`${err.rule}-${err.targetId}-${idx}`}
						className={`text-xs px-2 py-1.5 rounded ${
							err.type === "error"
								? "bg-accent-danger/10 text-accent-danger"
								: "bg-accent-secondary/10 text-accent-secondary"
						}`}
					>
						{err.message}
					</div>
				))}
			</div>
		</div>
	);
}
